<template>
    <div class="index-list-item item l-straight s-classical t-general e-firez-rabbitc-purple c-indigo"
        :class="isNew(data.pd_new, data.pd_new_end) ? 'is-new' : ''">
        <div class="item-box">
            <time>{{ data.pd_date |  moment("YYYY-MM-DD") }}</time>
            <figure>
                <a :href="getLinkUrl(data.pd_id)" class="" target="_blank">
                <img class="lazyLoad isLoaded" :src=data.pd_view_img></a>
            </figure>
            <hgroup>
                <h2> {{$tt(data.pd_num) }}</h2> 
                <div>
                    <a :href="getLinkUrl(data.pd_id)" class="is-detail" target="_blank">{{ $tt('细节') }}</a>
                    <a :href="getDemoLinkUrl(data.pd_id)" class="is-livedemo" target="_blank">{{$tt('现场演示')}}</a>
                </div>
            </hgroup>
            <span :style="getBackgroundColor(data.pd_colors)"></span>
        </div>
    </div>
</template>

<script type="application/javascript">
export default {
    props: ["data"],
    data() {
        return {            
            isH5: false
        }
    },
    methods: {
        // getImageSrc(imgUrl) {
        //     // const url = "https://web.bbinpartner.com/" + imgUrl
        //     // return url;
        //     return require(`${imgUrl}`);

        // },
        getLinkUrl(id){
            return "detail/" + id;
        },
        getDemoLinkUrl(id){
            return this.isH5 ? this.data.mobile_url : this.data.pc_url;
        },
        isNew(isNew, dateEnd){
            return (isNew === 1 && Date.parse(dateEnd) >= Date.now()) ? true : false;
        },
        getBackgroundColor(colors){
            let bgColors = colors.split(',');
            let firstColor = bgColors[0].replace('[\"','').replace('\"', '');
            let lastColor = bgColors[1].replace('\"]','').replace('\"', '');
            let bg = firstColor && lastColor ? `background: linear-gradient(to right, ${firstColor} 0%, ${lastColor} 100%)` : '';
            return bg;

        }
    },
    mounted () {
        this.isH5 = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    }
}
</script>